import type { CreateUserRequest, UserDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function createUserDetails(formData: CreateUserRequest): Promise<UserDetailed> {
  return requestApiJsonOrThrow<UserDetailed>('admin/users', {
    method: 'POST',
    body: formData,
  })
}
